/*
 * @Author: maxwellllu
 * @Date: 2023-05-31 14:56:21
 * @LastEditors: maxwellllu
 * @LastEditTime: 2023-06-06 14:56:15
 * @FilePath: /privatization-webim/src/utils/initXmlMsg.js
 * @Description: 广交会发送进线结构化消息
 */
import { initXmlObj } from './xmlMsg/gjhInitXml';
import AUTH_TYPE from '@/utils/authType';
import { GET_MSG_INFO_DATA } from '@/utils/api';
import ajax from '@/utils/ajax';
import globalWin from '@/utils/globalWin';
import i18n from '@/i18n';

export async function getInitXmlMsg(msginfo = {}, authType = '') {
  if (!msginfo) {
    return;
  }
  const xmlMsg = await getXmlTmp(msginfo, authType);
  return xmlMsg;
}

function checkMsgInfoVersion(msginfo) {
  let version = 1;
  if ((msginfo.itemId && (msginfo.buyerId || msginfo.userId))
    || (msginfo.orderId && (msginfo.buyerId || msginfo.userId))) {
    version = 2;
  }
  return version;
}

async function getXmlTmp(msginfo, authType = '') {
  const version = checkMsgInfoVersion(msginfo);
  switch (version) {
    case 1:
      return getXmlTmlByMsgInfo(msginfo);
    case 2: {
      const msgInfoRes = await fetchMsgInfo(msginfo, authType);
      return getXmlTmlByMsgInfo(msgInfoRes);
    }
    default:
      break;
  }
}

function getXmlTmlByMsgInfo(msginfo) {
  const msgId = +msginfo.msgId;
  const handlerName = initXmlObj.xmlTmpHanderMap[msgId];
  return initXmlObj[handlerName](msginfo);
}

function fetchMsgInfo(msginfo, authType = '') {
  const langMap = {
    zh: 'zh-cn',
    en: 'en-us',
    'zh-TW': 'zh-tw',
  };
  const lang = i18n.locale;
  return new Promise((resolve) => {
    const authConfig = AUTH_TYPE[authType || 'LingHang'];
    const { apiDomain = '', authDomain = '' } = authConfig;
    const { itemId, buyerId, orderId, userId, shopId } = msginfo;
    const kfuin = globalWin?.wpaDetail?.kfuin || globalWin.kfuin;
    const { appid, aid, d2 } =  globalWin.auth;
    const headers = {
      'X-Appid': appid,
      'X-Aid': aid,
      'X-D2': d2,
      'X-Tenant-Id': globalWin.kfuin,
    };
    const scene = itemId && (buyerId || userId) ? 1 : 2;
    const params = {
      kfuin,
      scene,
      apiDomain,
      authDomain,
      itemId,
      buyerId,
      orderId,
      shopId,
      lang: langMap[lang] || 'zh-cn',
    };

    ajax.post(
      GET_MSG_INFO_DATA,
      params,
      { headers },
    )
      .then((res) => {
        const { data } = res;
        if (+data.code === 0) {
          resolve(data.data);
        }
      })
      .catch(() => {
        resolve({});
      });
  });
}
